import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import FaIcon from "~/components/FaIcon";

import {
    Wrapper,
    Content,
    ArticleLink,
    Title,
    Footer,
    ReadMore,
    ReadMoreIcon,
} from "~/components/NewsCard";

import useStringTranslation from "~/hooks/translations/useStringTranslation";

const Date = styled.div`
    font-size: 1.8rem;
`;

const BoldTitle = styled(Title)`
    font-weight: 600;
    margin-bottom: 0;
`;

const Location = styled.div`
    font-size: 1.8rem;
`;

const Icon = styled(FaIcon)`
    font-size: 1.8rem;
    color: ${({ theme }) => theme.palette.grayOne};
`;

const Info = styled.div`
    margin-bottom: 20px;
`;

const EventCardSmall = ({
    title,
    date,
    location = "",
    url,
    withIcon = false,
    backgroundColor = "white",
}) => {
    const { eventDetailsText } = useStringTranslation([
        { text: "Event Details", handle: "eventDetailsText" },
    ]);

    return (
        <Wrapper {...{ backgroundColor }}>
            <Content>
                <ArticleLink to={url}>
                    <BoldTitle>{title}</BoldTitle>
                </ArticleLink>
                <Info>
                    {date ? <Date>{date}</Date> : null}
                    {location ? <Location>{location}</Location> : null}
                </Info>
                <Footer>
                    <ReadMore>
                        {eventDetailsText}
                        <ReadMoreIcon name="chevron-right" />
                    </ReadMore>
                    {withIcon ? <Icon name="calendar" /> : null}
                </Footer>
            </Content>
        </Wrapper>
    );
};

EventCardSmall.propTypes = {
    backgroundColor: PropTypes.oneOf(["white", "gray"]),
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    location: PropTypes.string,
    url: PropTypes.string.isRequired,
    withIcon: PropTypes.bool,
};

export default EventCardSmall;
